import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  showModal as showUpgradeModal,
  setPaymentRouteType,
} from 'ducks/trialWarning'
import { createApiKey } from 'ducks/apikeys'
import { showModal, INTEGRATION_TRIAL_MODAL } from 'ducks/editor/modals'

const useHandleTrialOrUpgrade = (appId, trialState, type, appApiKey) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const openUpgradeModal = async () => {
    await dispatch(setPaymentRouteType('upgrade'))
    await dispatch(showUpgradeModal())
  }

  const openIntegrationModal = async () => {
    await dispatch(showModal(INTEGRATION_TRIAL_MODAL, { type, appId }))

    if (type === 'externalCollection') {
      history.push(`/apps/${appId}/data/new-external-collection`)
    } else if (type === 'api') {
      if (!appApiKey) {
        await createApiKey(appId)
      }

      window.open(`/apps/${appId}/api-docs`)
    }
  }

  const handleTrial = async () => {
    try {
      if (trialState === 'after' || trialState === 'during') {
        await openUpgradeModal()
      } else {
        await openIntegrationModal()
      }
    } catch (err) {
      // modal closed
      console.error("modal closed, here's the error:", err)
    }
  }

  return handleTrial
}

export default useHandleTrialOrUpgrade
